export default __webpack_public_path__ + "static/media/pro-1.4f6b7298.png";